import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import GTMClickEvent from './GTMClickEvent';
const GTMClickEvents = ({
  gtmEvents,
  componentProps,
  parentComponent
}) => gtmEvents.map((event, index) => {
  const {
    eventName
  } = event;
  const dynamicKey = [eventName, index].join('-');
  return /*#__PURE__*/React.createElement(GTMClickEvent, _extends({
    key: dynamicKey,
    event: event,
    componentProps: componentProps,
    parentComponent: parentComponent
  }, event));
});
GTMClickEvents.propTypes = {
  gtmEvents: PropTypes.array,
  componentProps: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  parentComponent: PropTypes.object
};
GTMClickEvents.defaultProps = {
  gtmEvents: [],
  componentProps: {},
  parentComponent: {}
};
export default GTMClickEvents;
//# sourceMappingURL=GTMClickEvents.js.map